﻿import { View } from '@appstractdk/as-core';
import stringToHTML from '../libs/stringToHTML';
import positionDropdown from './misc/position-dropdown';

export default class Dropdown extends View {
	constructor(el, data, handler, library, keepOpenOnSelectOption = false, hasSearch = true, withoutListeners = false) {
		super(el);
		const dictionaryTemplateNode = document.importNode(document.querySelector("#default-dictionary-template").content, true).querySelector(".default-dictionary-template");
		this.dictionaryTemplate = dictionaryTemplateNode.cloneNode(true);

		this.data = data;
		this.handler = handler;
		this.library = library;
		this.hasSearch = hasSearch;
		this.withoutListeners = withoutListeners;
		this.keepOpenOnSelectOption = keepOpenOnSelectOption;
		this.dropdownType = this.el.getAttribute("data-type") || 'default';
		
		this.hasDropdown = false;
		this.isActive = false;
		this.checkedAllState = true;
		this.options = [];
		this.select = this.el.querySelector(".js-select-field");
		this.optionName = this.select.getAttribute("data-options-name");
		this.arrowStyle = this.el.classList.contains("simple") ? 
		`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.668 4.07" class="arrow-down select_number_arrow">
			<path id="Path_7885" data-name="Path 7885" d="M2.829,0,5.668,4.071H0Z" transform="translate(5.668 4.07) rotate(180)" opacity="0.6"/>
		</svg>`
		: 
		`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.121 8.121" class="arrow-down arrow_down_black">
			<g id="Group_11137" data-name="Group 11137" transform="translate(1.061 1.061)">
			<line id="Line_5" data-name="Line 5" x2="6" y2="6" fill="none" stroke="#001f25" stroke-linecap="round" stroke-width="1.5"/>
			<line id="Line_6" data-name="Line 6" x1="6" y2="6" transform="translate(6)" fill="none" stroke="#001f25" stroke-linecap="round" stroke-width="1.5"/>
			</g>
		</svg>`;


		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.removeDropdown = this.removeDropdown.bind(this);
		this.selectOption = this.selectOption.bind(this);

		this.initSelectOptions();
		this.presetOptionValue();


		if(this.withoutListeners) { return; }

		this.el.querySelector(".niceform-select").addEventListener("click", this.toggleDropdown, true);
		// document.body.addEventListener("click", this.removeDropdown, true);
		[...this.el.querySelectorAll(".dropdown-selection")].forEach(option => {
			option.addEventListener("click", this.selectOption, true);
		});

		this.addListener("click", "body", this.removeDropdown);
		//this.addListener("click", ".dropdown-selection", this.selectOption);

		window.addEventListener("resize", this.debounce(this.onResize.bind(this), 50), true);
	}

	selectOption(e, target) {
		e.stopPropagation();
		e.preventDefault();

		target = e.currentTarget;
		
		if(this.handler.isLoading) { return; }
		
		const activeSelection = this.el.querySelector(".dropdown-selection.selected");
		if (activeSelection) { activeSelection.classList.remove("selected"); }
		this.updateElem(target, target.dataset.idx);
		
		this.library.emit("OnDropdownSelect", target, this.el);

		if(this.dropdownType === 'locations') {
			this.library.emit("OnLocationDropdownItemSelect", target);
		}

		if(this.dropdownType === 'countries') {
			this.library.emit("OnCountriesDropdownItemSelect", target);
		}


		if(this.keepOpenOnSelectOption) { return; }

		this.toggleDropdown(e);

		if(this.el.getAttribute("data-reload-url")) {
			window.location.href = window.location.origin + target.getAttribute("data-value");
		}
	}

	initSelectOptions() {
		//this.data.forEach(obj => this.select.appendChild(stringToHTML(`<option value=${obj.Value}>${obj.Text}</option>`)));
		this.options = [...this.select.querySelectorAll("option")];
	}

	presetOptionValue() {
		const value = this.handler.data["dropdowns"][this.optionName]["selected"];

		this.createDropdown();

		let dropdownOption = [...this.el.querySelectorAll(".dropdown-selection")].find(opt => opt.dataset.idx === value);
		if (!dropdownOption) {
			dropdownOption = [...this.el.querySelectorAll(".dropdown-selection")][0];
		}

		this.updateElem(dropdownOption, value);
	}

	createDropdown() {
		const placeholder = this.el.querySelector(".niceform-select-wrapper");
		if(placeholder) {
			placeholder.parentNode.removeChild(placeholder);
		}

		const markup = `
            <div class="niceform-select-wrapper">
				<div class="niceform-select c-field">
					<div class="niceform-select-text-container">
						<svg class="dropdown-option-item-icon" focusable="false">
							<use xlink:href="/dist/images/${this.dropdownType === 'locations' ? `placeholder` : `en`}.svg"></use>
						</svg>
						<div class="niceform-select-text"></div>
					</div>
					${this.arrowStyle}					
                </div>
                <div class="niceform-options c-field">
					<div class="niceform-options-holder options-holder">
						${this.hasSearch ? 
							`<div class="niceform-option-search-container options-holder">
								<input type="text" class="niceform-option-search-input options-holder" placeholder="${this.dictionaryTemplate.querySelector(".search-placeholder-" + this.dropdownType).innerHTML}" value="">
								<div class="niceform-option-search-icon search" focusable="false"></div>
							</div>`
							: 
							""
						}
						<div class="niceform-options-holder-scrollbar-container options-holder">
							${this.data.map(obj => this[this.dropdownType](obj)).join("")}
						</div>
					</div>
                </div>
             </div>
        `;
		this.el.appendChild(stringToHTML(markup));

		this.searchInput = this.el.querySelector(".niceform-option-search-input");
		this.optionsList = this.el.querySelector(".niceform-options-holder-scrollbar-container.options-holder");
		this.dropdownContainer = this.el.querySelector(".niceform-options-holder");

		if(this.searchInput) {
			this.searchInput.addEventListener('keyup', this.filterOptionListWhenType.bind(this));
		}
		

		this.selectedPlaceHolderText = this.el.querySelector(".niceform-select-text-container");
		this.hasDropdown = true;
	}

	onResize() {
		if (!this.isActive) { return; }

		positionDropdown(this.dropdownContainer, this.el, false);
	}

	debounce(func, wait, immediate) {
        if (immediate === void 0) { immediate = false; }
        var timeout;
        return function () {
            var context = this, args = arguments;
            timeout !== null && clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            }, wait);
            if (immediate && !timeout)
                func.apply(context, args);
        };
    }

	filterOptionListWhenType(event) {
		const keyword = this.searchInput.value.toLowerCase();
		let filtered = this.handler.data.dropdowns[this.optionName].markup
			.filter(obj => {
				let title = obj.title.toLowerCase();
				if(title.indexOf(keyword) > -1){
					return obj;
				}
			});
		
		this.renderList(filtered);

	}

	renderList(list){
		if(list.length === 0) {
			
			this.optionsList.innerHTML = 
				`<div class="niceform-option dropdown-selection no-results">
					<p class="no-dropdown-search-results-found">${this.dictionaryTemplate.querySelector(".no-dropdown-search-results-found").innerHTML}</p>
				</div>`;

			return;
		}

		this.optionsList.innerHTML = list.map(item => item.value).join("");

		// Add event listeners again...
		[...this.el.querySelectorAll(".dropdown-selection")].forEach(option => {
			option.addEventListener("click", this.selectOption, true);
		});
	}

	locations(obj) {
		const markup = `<div class="niceform-option dropdown-selection" data-idx="${obj.id}" ${obj.checkAll ? `data-check-all="true"` : ``}>
							<div class="dropdown-option-item-left-container">
								<svg class="dropdown-option-item-icon location-item-icon" focusable="false">
									<use xlink:href="/dist/icons.svg#placeholder"></use>
								</svg>
								<h4 class="dropdown-option-item-title">${obj.Text}</h4>
								<p class="dropdown-option-item-description">${obj.description}</p>
							</div>
							<label class="form-item">
								<input name="${obj.Name}" value="${obj.id}" type="checkbox" class="checkbox-field" checked>
								<span class="checkbox-style"></span>
							</label>
						</div>`;

		this.handler.data["dropdowns"][this.optionName]["markup"].push({ title: obj.Text, value: markup });

		return markup;
	}

	countries(obj) {
		const markup = `<div class="niceform-option dropdown-selection countries-dropdown" data-value="${obj.Value}" data-idx="${obj.id}">
							<div class="dropdown-option-item-left-container">
								${obj.id ? 
									`<div class="flag ${obj.id.toLowerCase()}"></div>`
									: 
									""
								}
								
								<h4 class="dropdown-option-item-title">${obj.Text}</h4>		
							</div>
							${obj.countryCurrency ? `<p class="dropdown-option-item-country-code">${obj.countryCurrency}</p>` : ``}
						</div>`;

		this.handler.data["dropdowns"][this.optionName]["markup"].push({ title: obj.Text, value: markup });
		return markup;
	}

	default(obj) {
		return `<div class="niceform-option dropdown-selection default-dropdown ${obj.logoutApi ? `red` : ``}" data-value="${obj.Value}" data-idx="${obj.id}" ${obj.logoutApi ? `data-logout-api="${obj.logoutApi}"` : ``}>
					<div class="dropdown-option-item-left-container">
						<h4 class="dropdown-option-item-title">${obj.Text}</h4>	
					</div>
				</div>`;
	}

	toggleDropdown(e) {
		e.stopPropagation();
		if (!this.hasDropdown) { this.createDropdown(); }

		// Loop through the other Dropdowns and close them
		// this.data.dropdowns = [] from app.js

		Object.values(this.handler.data["dropdowns"])
			.map(obj => {
				const inst = obj.class;

				if(!inst) { return; }

				if (inst.el !== this.el) {
					inst.el.classList.remove("active");
					inst.isActive = false;
				}
			});

		this.el.classList.toggle("active");
		this.isActive = !this.isActive;

		if(this.isActive) {
			positionDropdown(this.dropdownContainer, this.el, false);
		}
	}

	removeDropdown(e) {
		if (e.target.classList.contains("options-holder")) { return; }
		if (this.hasDropdown && this.isActive) { this.toggleDropdown(e); }
	}

	updateElem(elem, optIndx) {
		const option = this.options.find(option => option.getAttribute("data-id") === optIndx);
		const value = elem.querySelector(".dropdown-option-item-left-container");
		elem.classList.add("selected");
	
		this.selectedPlaceHolderText.innerHTML = value.innerHTML;
		
	
		if(!option) { return; }
		option.selected = true;

		//this.handler.setProperty(this.optionName + "-selected", optIndx);
		this.handler.data["dropdowns"][this.optionName]["selected"] = optIndx;
	}

}